module.exports = __webpack_public_path__ + "img/info1.c98e0de6.png";